import UAParser from 'ua-parser-js';

const uaParser = new UAParser(navigator.userAgent);
const device = uaParser.getDevice();
const browser = uaParser.getBrowser();
const IE = 'IE';

/** @type {boolean}*/
export const isMobile = device.type === 'mobile';

/** @type {boolean}*/
export const isDesktop = !device.type;

/** @type {boolean}*/
export const isIe = browser.name === IE;
